import { render, staticRenderFns } from "./new-device-form.vue?vue&type=template&id=4bb4d123"
import script from "./new-device-form.vue?vue&type=script&lang=js"
export * from "./new-device-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports